import { Chip } from '@mui/material'

type CrmStatusProps = {
  /** A Hebrew status label, or a CRM status key / section (to_do, in_progress, done, …). */
  value: string
  /** Text to show when `value` is a key; defaults to `value`. */
  label?: string
}

type Tone = 'open' | 'in_progress' | 'done'

const TONE_BY_VALUE: Record<string, Tone> = {
  // Hebrew labels (used by the consumer / sensor / analytics grids)
  פתוח: 'open',
  בתהליך: 'in_progress',
  בוצע: 'done',
  // CRM status keys and sections from /api/crm
  to_do: 'open',
  open: 'open',
  in_progress: 'in_progress',
  done: 'done',
  closed: 'done',
  cancelled: 'done',
}

const TONE_COLORS: Record<Tone, { bg: string; text: string }> = {
  open: { bg: '#F2FCEE', text: '#4D8B43' },
  in_progress: { bg: '#FFF4E1', text: '#A66A00' },
  done: { bg: '#46BE8B', text: '#EFF2F7' },
}

export default function CrmStatus({ value, label }: CrmStatusProps) {
  const tone = TONE_BY_VALUE[value]
  const bgColor = tone ? TONE_COLORS[tone].bg : '#37474F'
  const textColor = tone ? TONE_COLORS[tone].text : '#EFF2F7'

  return (
    <Chip
      label={label ?? value}
      sx={{
        fontWeight: 500,
        fontSize: '14px',
        px: 1,
        backgroundColor: bgColor,
        color: textColor,
      }}
    />
  )
}
